<template lang="pug">
  button.btn.fpui-button(:class='className', :type='type' @click='onClick', :disabled='disabled')
    i(v-if="icon", :class="iconClass")
    span.btn-content(v-if="$slots.default")
      slot
    .clearfix
</template>

<script>
import debounce from 'lodash/debounce'
  export default {
    props: {
      icon: { type: String },
      iconLeft: { type: Boolean, default: false },
      iconCenter: { type: Boolean, default: false },
      unbordered: { type: Boolean, default: false },
      color: { type: String, default: 'blue' },
      disabled: { type: Boolean, default: false },
      reverse: { type: Boolean, default: false },
      capitalize: { type: Boolean, default: false },
      center: { type: Boolean, default: false },
      type: { type: String, default: 'button' },
      toolbar: { type: Boolean, default: false },
      theme: { type: String, default: 'v3' },
      defer: {}
    },
    computed: {
      iconClass () {
        let iconClass = [this.icon]
        if (this.iconLeft) iconClass.push('pull-left')
        if (!this.iconLeft && this.iconCenter) iconClass.push('pull-center')
        if (!this.iconLeft && !this.iconCenter) iconClass.push('pull-right')
        return iconClass.join(' ')
      },
      className () {
        let className = [this.color]
        if (this.toolbar) {
          className.push('toolbar')
          className.push('reverse')
          className.push('unbordered')
        }
        if (this.disabled) className.push('disabled')
        if (this.reverse) className.push('reverse')
        if (this.unbordered) className.push('unbordered')
        if (this.capitalize) className.push('capitalize')
        if (this.center) className.push('text-center')
        className.push(this.theme)
        return className.join(' ')
      }
    },
    methods: {
      onClick (e) {
        if (this.defer == "" || this.defer) return this.onClickDefer(e)
        if (!this.disabled && !this.defer) this.$emit('click', e)
      },
      onClickDeferFn () {
        if (!this.disabled) this.$emit('click')
      },
      onClickDefer () {
        let defer = parseInt(this.defer) || 500
        if(!this.test) this.test = debounce(this.onClickDeferFn,  defer, { 'leading': true, 'trailing': false, 'maxWait': defer })
        this.test.call(this)
      }
    }
  }
</script>

<style lang="less">
@import "~@/shared/styles/_variables.less";
@import "~@/shared/styles/theme_v4/_variables.less";

// theme_v3
.btn.fpui-button.v3 {
  height:34px;
  border-radius: 3px;
  padding: 6px 12px;
  text-transform: uppercase;
  letter-spacing: 1px;
  font-size: 14px;
  font-weight: 300;
  cursor:pointer;
  line-height: 20px;
  outline: none!important;
  box-shadow: none!important;
  text-align: left;
  border: 1px solid transparent;
  cursor: pointer;
  &.text-center {
    text-align: center;
  }
  &.capitalize {
    text-transform: capitalize;
  }
  .input-transition();
  i.fa {
    line-height: 20px;
  }
  i {
    display: inline-block;
    margin: 0;
  }
  i.pull-left+span {
    margin-left: 10px;
  }
  i.pull-right+span {
    margin-right: 10px;
  }
  i.pull-center+span {
    margin: 0 auto;
  }
  i.fp, i.fpui {
    line-height: 1.45;
  }
  &.pull-left i, i.pull-left {
    padding: 0;
    line-height: 1.45;
  }
  &.green {
    border-color: @green;
    &.reverse {
      background-color: transparent;
      color: @green;
    }
    &:not(.reverse), &:hover:not(.disabled) {
      background-color: @green;
      color: @white;
    }
    .input-button-disabled();
  }
  &.grey {
    border-color: @grey;
    &.reverse {
      background-color: transparent;
      color: @grey;
    }
    &:not(.reverse), &:hover:not(.disabled) {
      background-color: @grey;
      color: #000;
    }
    .input-button-disabled();
  }
  &.red {
    border-color: @red;
    &.reverse {
      background-color: transparent;
      color: @red;
    }
    &:not(.reverse), &:hover:not(.disabled) {
      background-color: @red;
      color: @white;
    }
    .input-button-disabled();
  }
  &.blue {
    border-color: @blue;
    &.reverse {
      background-color: transparent;
      color: @blue;
    }
    &:not(.reverse), &:hover:not(.disabled) {
      background-color: @blue;
      color: @white;
    }
    .input-button-disabled();
  }
  &.yellow {
    border-color: @yellow;
    &.reverse {
      background-color: transparent;
      color: @yellow;
    }
    &:not(.reverse), &:hover:not(.disabled) {
      background-color: @yellow;
      color: @white;
    }
    .input-button-disabled();
  }
  &.transparent {
    border: none;
    padding: 0;
    background-color: transparent;
    &:hover {
      background-color: transparent;
    }
  }

  &.unbordered {
    border: 0;
    text-transform: none;
    &:hover {
      background-color:transparent!important;
      &.green {
        color: @green;
      }
      &.blue {
        color: @blue;
      }
      &.red {
        color: @red;
      }
      &.yellow {
        color: @yellow;
      }
    }
    i {
      font-size: 15px;
    }
  }

  &.toolbar.reverse {
    color:#aaa;
  }



  &:disabled {
    opacity: 0.3;
    cursor: not-allowed;
  }
}

// Theme_v4
.btn.fpui-button.v4 {
  height:34px;
  border-radius: 5px;
  padding: 6px 12px;
  text-transform: uppercase;
  letter-spacing: 1px;
  font-size: 14px;
  font-weight: 300;
  cursor:pointer;
  line-height: 20px;
  outline: none!important;
  box-shadow: inset 0 -1px 0 0 rgba(0,0,0,0.07), 0 5px 8px 0 rgba(0,0,0,0.14);
  text-align: left;
  border: 1px solid transparent;
  cursor: pointer;
  &.text-center {
    text-align: center;
  }
  &.capitalize {
    text-transform: capitalize;
  }
  .input-transition();
  i.fa {
    line-height: 20px;
  }
  i {
    display: inline-block;
    margin: 0;
  }
  i.pull-left+span {
    margin-left: 10px;
  }
  i.pull-right+span {
    margin-right: 10px;
  }
  i.pull-center+span {
    margin: 0 auto;
  }
  i.fp, i.fpui {
    line-height: 1.45;
  }
  &.pull-left i, i.pull-left {
    padding: 0;
    line-height: 1.45;
  }
  &.green {
    border-color: @green_v4;
    &.reverse {
      background-color: transparent;
      color: @green_v4;
    }
    &:not(.reverse), &:hover:not(.disabled) {
      background-color: @green_v4;
      color: @white;
    }
    .input-button-disabled();
  }
  &.grey {
    border-color: @grey_v4;
    &.reverse {
      background-color: transparent;
      color: @grey_v4;
    }
    &:not(.reverse), &:hover:not(.disabled) {
      background-color: @grey_v4;
      color: #000;
    }
    .input-button-disabled();
  }
  &.red {
    border-color: @red;
    &.reverse {
      background-color: transparent;
      color: @red;
    }
    &:not(.reverse), &:hover:not(.disabled) {
      background-color: @red;
      color: @white;
    }
    .input-button-disabled();
  }
  &.blue {
    border-color: @blue_v4;
    &.reverse {
      background-color: transparent;
      color: @blue_v4;
    }
    &:not(.reverse), &:hover:not(.disabled) {
      background-color: @blue_v4;
      color: @white;
    }
    .input-button-disabled();
  }
  &.yellow {
    border-color: @yellow;
    &.reverse {
      background-color: transparent;
      color: @yellow;
    }
    &:not(.reverse), &:hover:not(.disabled) {
      background-color: @yellow;
      color: @white;
    }
    .input-button-disabled();
  }
  &.transparent {
    border: none;
    padding: 0;
    background-color: transparent;
    &:hover {
      background-color: transparent;
    }
  }

  &.unbordered {
    border: 0;
    text-transform: none;
    &:hover {
      background-color:transparent!important;
      &.green {
        color: @green_v4;
      }
      &.blue {
        color: @blue_v4;
      }
      &.red {
        color: @red;
      }
      &.yellow {
        color: @yellow;
      }
    }
    i {
      font-size: 15px;
    }
  }

  &.toolbar.reverse {
    color:#aaa;
  }



  &:disabled {
    opacity: 0.3;
    cursor: not-allowed;
  }
}

</style>
